// Regions are ISO 3166-1 alpha-2 country codes ("PH", "IN", "HK"). Names come from the browser,
// so there is no list to maintain.
let names = null;
const display = () => {
  if (!names) {
    try {
      names = new Intl.DisplayNames(["en"], { type: "region" });
    } catch (e) {
      names = { of: (c) => c };
    }
  }
  return names;
};

export const regionName = (code) => {
  if (!code) return "";
  try {
    return display().of(String(code).toUpperCase()) || code;
  } catch (e) {
    return code;
  }
};

// All selectable regions, sorted by name.
export const regionOptions = () => {
  const out = [];
  const A = "A".charCodeAt(0);
  for (let i = 0; i < 26; i++) {
    for (let j = 0; j < 26; j++) {
      const code = String.fromCharCode(A + i) + String.fromCharCode(A + j);
      let name = "";
      try {
        name = display().of(code);
      } catch (e) {
        name = "";
      }
      if (name && name !== code) out.push({ value: code, label: `${name} (${code})` });
    }
  }
  return out.sort((a, b) => a.label.localeCompare(b.label));
};
